import { AxiosResponse } from 'axios';

import { IErrorResponse } from '../api/errors';
import axios, { axiosClassic } from '../api/intercepors';
import {
  getAdminReviews,
  getCardUrl,
  getComment,
  getLike,
  getReviews,
  setCommentUrl,
} from '../config/url.config';
import { ICardResponse } from '../store/card/card.interface';
import {
  ICommentDataResponse,
  ICommentResponse,
  IReview,
  IReviewComment,
  IReviewCommentResponse,
  IReviewResponse,
} from '../store/review/review.interface';

export const CardService = {
  async getOne(slug: string) {
    return await axiosClassic.get<ICardResponse>(getCardUrl(slug));
  },
};
